const adapterKey = Symbol.for('mybiashub.rewardhub.events.adapter');

if (!globalThis[adapterKey]) {
  globalThis[adapterKey] = true;

  let cartUpdateFrame;
  let variantUpdateFrame;

  const dispatchAfterRender = (eventName, frameKey) => {
    if (frameKey === 'cart' && cartUpdateFrame !== undefined) return;
    if (frameKey === 'variant' && variantUpdateFrame !== undefined) return;

    const frame = requestAnimationFrame(() => {
      if (frameKey === 'cart') cartUpdateFrame = undefined;
      if (frameKey === 'variant') variantUpdateFrame = undefined;
      document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
    });

    if (frameKey === 'cart') cartUpdateFrame = frame;
    if (frameKey === 'variant') variantUpdateFrame = frame;
  };

  const cartUpdated = (event) => {
    if (event.detail?.data?.didError || event.detail?.resource?.status) return;
    dispatchAfterRender('rewardhub:cart-updated', 'cart');
  };

  document.addEventListener('cart:update', cartUpdated);
  document.addEventListener('discount:update', cartUpdated);
  const productUpdated = () => {
    dispatchAfterRender('rewardhub:variant-changed', 'variant');
  };
  document.addEventListener('variant:update', productUpdated);
  document.addEventListener('quantity-selector:update', productUpdated);
}
